import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { TicketBookingEditPartial, TicketBookingEditProps } from '../partials/TicketBookingEditPartial';

function TicketBookingEdit(props: TicketBookingEditProps) {
  return <TicketBookingEditPartial {...props} />;
}

export const TicketBookingEditView = asFetchableView(TicketBookingEdit);
export type TicketBookingEditView = ComponentProps<typeof TicketBookingEditView>;
